
  import {
    Component,
    Vue,
    Inject,
    Prop,
    Watch,
    Ref
  } from "vue-property-decorator";
  import api from "@/api";
  import Tinymce from "@/components/Tinymce/index.vue";
  import { CmsCategoryCreateOrUpdateDto } from "@/api/appService";
  import { ElForm } from "element-ui/types/form";

  @Component({
    components: { Tinymce }
  })
  export default class CreateCmsCategory extends Vue {
    @Ref() readonly dataForm!: ElForm;
    form: CmsCategoryCreateOrUpdateDto = {
      name: undefined,
      categoryCode: undefined,
      description: undefined,
      id: 0
    }


    created(){
      if(this.$route.params.id){
        api.cmsCategory.get({id:Number(this.$route.params.id)}).then(res=>{
          this.form = {...res};
        })
      }

    }



    async save() {
      (this.$refs.dataForm as any).validate(async (valid: boolean) => {
        if (valid) {
          if (this.form!.id) {
            await api.cmsCategory.update({
              body: this.form
            });
          } else {
            await api.cmsCategory.create({
              body: this.form
            });
          }
          this.$router.back();
          this.$message.info("更新成功");

        }
      });
    }

    cancel() {
      this.$router.back();
      // (this.$refs.dataForm as any).resetFields();
      // this.$emit("input", false);
    }

    roleRule = {
      name: [
        {
          required: true,
          message: "分类名称 必填",
          trigger: "blur"
        }
      ],
      categoryCode: [
        {
          required: true,
          message: "必填",
          trigger: "blur"
        }
      ],
      description: [
        {
          required: true,
          message: "必填",
          trigger: "blur"
        }
      ]
    };
  }
